/**
 * Shared in-memory CSRF token cache for API gateway session tokens.
 * Used by BaseService and auth-page prefetch so log-login does not wait on cold fetch.
 */

let cachedCsrfToken: string | null = null;
let prefetchPromise: Promise<string> | null = null;

export function getCachedCsrfToken(): string | null {
  return cachedCsrfToken;
}

export function setCachedCsrfToken(token: string | null): void {
  cachedCsrfToken = token;
}

export function clearCachedCsrfToken(): void {
  cachedCsrfToken = null;
  prefetchPromise = null;
}

/**
 * Prefetch Csrf Token.
 */
export function prefetchCsrfToken(apiBaseUrl: string): Promise<string> {
  if (cachedCsrfToken) {
    return Promise.resolve(cachedCsrfToken);
  }

  if (!prefetchPromise) {
    prefetchPromise = fetch(`${apiBaseUrl}/api/csrf-token`, {
      method: "GET",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    })
      .then(async (response) => {
        if (!response.ok) {
          return "";
        }
        const data = (await response.json()) as { csrfToken?: string };
        const token = data.csrfToken ?? "";
        if (token) {
          cachedCsrfToken = token;
        }
        return token;
      })
      .catch(() => "")
      .finally(() => {
        prefetchPromise = null;
      });
  }

  return prefetchPromise;
}
